import UrlGroupingsBlocker from "./UrlGroupingsBlocker.js";
import ImagineAggRequestor from "./ImagineAggRequestor.js";
import ImagineGroupingFilterInstaller from "./ImagineGroupingFilterInstaller.js";
import RelationshipValueSource from "./RelationshipValueSource.js";
const install = molten => {
  molten.addPlugin('BlockerHook', UrlGroupingsBlocker.createPlugin());
  molten.addPlugin('Molten.GroupingAggRequestor', ImagineAggRequestor.createPlugin());
  molten.addPlugin('DataViewer', ImagineGroupingFilterInstaller.createPlugin());
  molten.addPlugin('Molten.GroupingValueSource', RelationshipValueSource.createPlugin());
};
export default {
  install
};